import { render, staticRenderFns } from "./SpacingBetweenVIcon.vue?vue&type=template&id=128f8196&"
import script from "./SpacingBetweenVIcon.vue?vue&type=script&lang=js&"
export * from "./SpacingBetweenVIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports